import PadsIcon from "./PadsIcon";
export default PadsIcon;
